/**
 * Frontend client for the session-slots API (TPB multi-account, Connect2id-style).
 *
 * Uses the ky `api` client (from ./api.ts) which automatically sends:
 * - `Logto-App-Id` header (needed for per-client interaction cookie resolution)
 * - `Accept-Language` header (i18n)
 *
 * Endpoints served by `routes/session-slots.ts` in core.
 */

import api from './api';

export type SlotAccount = {
  slot: string;
  accountId: string;
  email: string | null;
  name: string | null;
  avatar: string | null;
  isCurrent: boolean;
};

export const getSessionSlots = async (): Promise<SlotAccount[]> => {
  const data = await api.get('/api/session-slots').json<{ accounts: SlotAccount[] }>();
  return data.accounts ?? [];
};

export const selectSessionSlot = async (slot: string): Promise<void> => {
  await api.post('/api/session-slots/select', { json: { slot } });
};

export const removeSessionSlot = async (slot: string): Promise<void> => {
  await api.delete(`/api/session-slots/${slot}`);
};

export const clearAllSessionSlots = async (): Promise<void> => {
  await api.delete('/api/session-slots');
};
